<div class="filter-group" data-group-visibility-id="showGearCraftingBasesHighlights">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showGearCraftingBasesHighlights" (click)="filter.groupVisibility.showGearCraftingBasesHighlights = !filter.groupVisibility.showGearCraftingBasesHighlights; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Crafting Bases" [activeRules]="activeRules.craftingBaseFiltersPoe1">
          <app-content cid="crafting-bases-poe1" contentType="tip"></app-content>
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showGearCraftingBasesHighlights) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showGearCraftingBasesHighlights">

      <div class="filter filter-property full-span" [class.disabled]="!filter.showExcellentWeaponCraftingBases">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showExcellentWeaponCraftingBases" (click)="toggleHighlightExcellentWeaponCraftingBases()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="{{ isMobile() ? 'Qual. Weapons' : 'Excellent Quality Weapons' }}" [additionalContent]="excellentWeaponCraftingBasesStylePreview" ruleId="gear-crafting-bases-excellent-weapons">
            <strong>Excellent Quality Bases</strong> are <app-gear-tier-icon tier="Master"></app-gear-tier-icon> Master weapons with at least 28 quality.
            <br /><strong>Good Quality Bases</strong> are <app-gear-tier-icon tier="Master"></app-gear-tier-icon> Master weapons with at least 26 quality.

            <ng-template #excellentWeaponCraftingBasesStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherGearExcellentQualityWeapon"
                [alignLeft]="true"
                [active]="filter.showExcellentWeaponCraftingBases"
                exampleName="Example Weapon"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-autocomplete
            [options]="craftingBaseWeaponClasses"
            [disabled]="!filter.showExcellentWeaponCraftingBases"
            [showOptions]="true"
            [selectedValues]="filter.showWeaponCraftingBasesClasses || ['All']"
            (selectedValuesChange)="highlightWeaponCraftingBasesClassesChanged($event)"
          ></app-autocomplete>
          <span class="sep"></span>
          @if (!isMobile()) {
            <div class="filter-title filter-label">
              iLvl
            </div>
            <span class="sep"></span>
          }
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.minWidth]="isMobile() ? '45px' : null"
            [disabled]="!filter.showExcellentWeaponCraftingBases"
            [(ngModel)]="filter.showWeaponCraftingBasesMinItemLevel" (change)="updateFilter()">
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            filterPropertyName="showGoodWeaponCraftingBases"
            labelText="Good"
            [equipmentType]="EquipmentType.OtherGearGoodQualityWeapon"
            exampleName="Example Weapon"
            [disabledWhen]="!filter.showExcellentWeaponCraftingBases"></app-filter-checkbox-group>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showExcellentArmourCraftingBases">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showExcellentArmourCraftingBases" (click)="toggleHighlightExcellentArmourCraftingBases()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="{{ isMobile() ? 'Qual. Armour' : 'Excellent Quality Armour' }}" [additionalContent]="excellentArmourCraftingBasesStylePreview" ruleId="gear-crafting-bases-excellent-armour">
            <strong>Excellent Quality Bases</strong> are <app-gear-tier-icon tier="Master"></app-gear-tier-icon> Master armour with either at least:
            <br />- 28 quality;
            <br />- 26 quality and iLevel {{ filter.showArmourCraftingBasesMinItemLevel >= 84 ? filter.showArmourCraftingBasesMinItemLevel : 84 }};
            <br />- 24 quality and iLevel 86 Body Armour, Boots or Shields;
            <br />- 24 quality and iLevel {{ filter.showArmourCraftingBasesMinItemLevel >= 85 ? filter.showArmourCraftingBasesMinItemLevel : 85 }} Helmets or Gloves.
            <br />
            <br /><strong>Good Quality Bases</strong> are <app-gear-tier-icon tier="Master"></app-gear-tier-icon> Master armour with either at least:
            <br />- 26 quality and 60% defence percentile;
            <br />- 24 quality and 75% defence percentile;
            <br />- 22 quality and 90% defence percentile.

            <ng-template #excellentArmourCraftingBasesStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherGearExcellentQualityArmour"
                [alignLeft]="true"
                [active]="filter.showExcellentArmourCraftingBases"
                exampleName="Example Armour"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-autocomplete
            [options]="armourTypes"
            [disabled]="!filter.showExcellentArmourCraftingBases"
            [showOptions]="true"
            [selectedValues]="filter.showArmourCraftingBasesTypes || ['All']"
            (selectedValuesChange)="highlightArmourCraftingBasesTypesChanged($event)"
        ></app-autocomplete>
          <span class="sep"></span>
          @if (!isMobile()) {
            <div class="filter-title filter-label">
              iLvl
            </div>
            <span class="sep"></span>
          }
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.minWidth]="isMobile() ? '45px' : null"
            [disabled]="!filter.showExcellentArmourCraftingBases"
            [(ngModel)]="filter.showArmourCraftingBasesMinItemLevel" (change)="updateFilter()">
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            filterPropertyName="showGoodArmourCraftingBases"
            labelText="Good"
            [equipmentType]="EquipmentType.OtherGearGoodQualityArmour"
            exampleName="Example Armour"
            [disabledWhen]="!filter.showExcellentArmourCraftingBases"></app-filter-checkbox-group>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showExcellentQualityFlasks">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showExcellentQualityFlasks" (click)="toggleHighlightExcellentQualityFlasks()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="{{ isMobile() ? 'Qual. Flasks' : 'Excellent Quality Flasks' }}" [additionalContent]="excellentQualityFlasksStylePreview" ruleId="flasks-crafting-bases-excellent-quality">
            <strong>Excellent Quality Flasks</strong> have at least {{ filter.showExcellentQualityFlasksMinQuality }} quality.
            <br /><strong>Good Quality Flasks</strong> have at least {{ filter.showGoodQualityFlasksMinQuality }} quality.
            <ng-template #excellentQualityFlasksStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherFlasksExcellentQuality"
                [alignLeft]="true"
                [active]="filter.showExcellentQualityFlasks"
                exampleName="Superior Quicksilver Flask"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-autocomplete
            [allLabel]="'All'"
            [options]="utilityPlusTopLifeManaFlaskTypes"
            [disabled]="!filter.showExcellentQualityFlasks"
            [showOptions]="true"
            [selectedValues]="filter.showQualityFlaskTypes || ['All']"
            (selectedValuesChange)="filter.showQualityFlaskTypes = $event; updateFilter();"></app-autocomplete>
          <span class="sep"></span>
          @if (!isMobile()) {
            <div class="filter-title filter-label">
              iLvl
            </div>
            <span class="sep"></span>
          }
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax" [style.minWidth]="isMobile() ? '45px' : null"
            [disabled]="!filter.showExcellentQualityFlasks"
            [(ngModel)]="filter.showQualityFlasksMinILevel" (change)="updateFilter()">
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            filterPropertyName="showGoodQualityFlasks"
            labelText="Good"
            [equipmentType]="EquipmentType.OtherFlasksGoodQuality"
            exampleName="Superior Quicksilver Flask"
            [disabledWhen]="!filter.showExcellentQualityFlasks"></app-filter-checkbox-group>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showExcellentGearBaseTypes">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showExcellentGearBaseTypes" (click)="toggleHighlightExcellentGearBaseTypes()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="{{ isMobile() ? 'Gear Base Types' : 'Excellent Gear Base Types' }}" [additionalContent]="excellentGearBaseTypesStylePreview" ruleId="gear-crafting-bases-excellent-base-types">
            Excellent Gear Base Types are those which according to <a href="https://poe.ninja" target="_blank">poe.ninja</a> are worth at least 40c at ilvl 83. Good ones are worth at least 20c.
            <br /><br /><strong>Excellent</strong>: {{ excellentGearBaseTypes.join(', ') }}
            <br /><br /><strong>Good</strong>: {{ goodGearBaseTypes.join(', ') }}
            <ng-template #excellentGearBaseTypesStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherGearExcellentBaseTypes"
                [alignLeft]="true"
                [active]="filter.showExcellentGearBaseTypes"
                exampleName="{{ excellentGearBaseTypes[0] || 'Example Gear' }}"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          @if (!isMobile()) {
            <div class="filter-title filter-label">
              iLvl
            </div>
            <span class="sep"></span>
          }
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.minWidth]="isMobile() ? '45px' : null"
            [disabled]="!filter.showExcellentGearBaseTypes"
            [(ngModel)]="filter.showExcellentGearBaseTypesMinItemLevel" (change)="updateFilter()">
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            filterPropertyName="showGoodGearBaseTypes"
            labelText="Good"
            [equipmentType]="EquipmentType.OtherGearGoodBaseTypes"
            [exampleName]="goodGearBaseTypes[0] || 'Example Gear'"
            [disabledWhen]="!filter.showExcellentGearBaseTypes"></app-filter-checkbox-group>
          <span class="sep"></span>
          @if (!isMobile()) {
            <div class="filter-title filter-label">
              iLvl
            </div>
            <span class="sep"></span>
          }
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.minWidth]="isMobile() ? '45px' : null"
            [disabled]="!filter.showGoodGearBaseTypes"
            [(ngModel)]="filter.showGoodGearBaseTypesMinItemLevel" (change)="updateFilter()">
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showExcellentJewelleryBaseTypes">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showExcellentJewelleryBaseTypes" (click)="toggleHighlightExcellentJewelleryBaseTypes()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="{{ isMobile() ? 'Jewellery Base Types' : 'Excellent Jewellery Base Types' }}" [additionalContent]="excellentJewelleryBaseTypesStylePreview" ruleId="jewellery-crafting-bases-excellent-base-types">
            Excellent Jewellery Base Types are those which according to <a href="https://poe.ninja" target="_blank">poe.ninja</a> are worth at least 100c at ilvl 83. Good ones are worth at least 20c.
            <br /><br /><strong>Excellent</strong>: {{ excellentJewelleryBaseTypes.join(', ') }}
            <br /><br /><strong>Good</strong>: {{ goodJewelleryBaseTypes.join(', ') }}
            <ng-template #excellentJewelleryBaseTypesStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherJewelleryExcellentBaseTypes"
                [alignLeft]="true"
                [active]="filter.showExcellentJewelleryBaseTypes"
                exampleName="{{ excellentJewelleryBaseTypes[0] || 'Example Jewellery' }}"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          @if (!isMobile()) {
            <div class="filter-title filter-label">
              iLvl
            </div>
            <span class="sep"></span>
          }
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.minWidth]="isMobile() ? '45px' : null"
            [disabled]="!filter.showExcellentJewelleryBaseTypes"
            [(ngModel)]="filter.showExcellentJewelleryBaseTypesMinItemLevel" (change)="updateFilter()">
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            filterPropertyName="showGoodJewelleryBaseTypes"
            labelText="Good"
            [equipmentType]="EquipmentType.OtherJewelleryGoodBaseTypes"
            [exampleName]="goodJewelleryBaseTypes[0] || 'Example Jewellery'"
            [disabledWhen]="!filter.showExcellentJewelleryBaseTypes"></app-filter-checkbox-group>
          <span class="sep"></span>
          @if (!isMobile()) {
            <div class="filter-title filter-label">
              iLvl
            </div>
            <span class="sep"></span>
          }
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.minWidth]="isMobile() ? '45px' : null"
            [disabled]="!filter.showGoodJewelleryBaseTypes"
            [(ngModel)]="filter.showGoodJewelleryBaseTypesMinItemLevel" (change)="updateFilter()">
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showHighILevelFlasks">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showHighILevelFlasks" (click)="toggleHighlightHighILevelFlasks()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="{{ isMobile() ? 'High iLvl Flasks' : 'High iLevel Flasks' }}" [additionalContent]="highILevelFlasksPreview" ruleId="flasks-crafting-bases-ilevel">
            Utility Flasks, Tinctures, and Divine Life and Eternal Mana Flasks.
            <ng-template #highILevelFlasksPreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherFlasksILevel"
                [active]="filter.showHighILevelFlasks"
                exampleName="Quicksilver Flask"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-autocomplete
            [allLabel]="'All'"
            [options]="utilityPlusTopLifeManaFlaskTypes"
            [disabled]="!filter.showHighILevelFlasks"
            [showOptions]="true"
            [selectedValues]="filter.showHighILevelFlaskTypes || ['All']"
            (selectedValuesChange)="filter.showHighILevelFlaskTypes = $event; updateFilter();"></app-autocomplete>
          <span class="sep"></span>
          @if (!isMobile()) {
            <div class="filter-title filter-label">
              iLvl
            </div>
            <span class="sep"></span>
          }
          <input type="number" placeholder="Min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax" [style.minWidth]="isMobile() ? '45px' : null"
            [disabled]="!filter.showHighILevelFlasks"
            [(ngModel)]="filter.showHighILevelFlasksMinILevel" (change)="updateFilter()">
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showOtherSpecialJewelleryBaseTypes">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showOtherSpecialJewelleryBaseTypes" (click)="toggleHighlightOtherSpecialJewelleryBaseTypes()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Other Special {{ isMobile() ? '' : 'Jewellery' }} Base Types" [additionalContent]="otherSpecialJewelleryBaseTypesStylePreview" ruleId="jewellery-crafting-bases-other-special-base-types">
            <ng-template #otherSpecialJewelleryBaseTypesStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherJewelleryOtherSpecialBaseTypes"
                [alignLeft]="true"
                [active]="filter.showOtherSpecialJewelleryBaseTypes"
                exampleName="{{ specialJewelleryBaseTypes[0] || 'Example Jewellery' }}"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-autocomplete
            [options]="allOtherSpecialJewelleryBaseTypesTypes"
            [disabled]="!filter.showOtherSpecialJewelleryBaseTypes"
            [showOptions]="true"
            [selectedValues]="filter.showOtherSpecialJewelleryBaseTypesTypes || ['All']"
            (selectedValuesChange)="highlightOtherSpecialJewelleryBaseTypesTypesChanged($event)"
          ></app-autocomplete>
          <span class="sep"></span>
          @if (!isMobile()) {
            <div class="filter-title filter-label">
              iLvl
            </div>
            <span class="sep"></span>
          }
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.minWidth]="isMobile() ? '45px' : null"
            [disabled]="!filter.showOtherSpecialJewelleryBaseTypes"
            [(ngModel)]="filter.showOtherSpecialJewelleryBaseTypesMinItemLevel" (change)="updateFilter()">
        </span>
      </div>

    </div>
    <div class="clear"></div>
  }
</div>
